import { assignProps } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import { datasetDatasourceFeatureActions } from '../constants';
import { findDatasourceFeature, newDatasourceFeatures } from './state';

const fetchDatasourceFeaturesError = withDraft((draft, action) => {
  const item = findDatasourceFeature(draft, action);
  if (item) {
    item.readStatus = states.ERROR;
    item.readErrors = [responseError(action)];
  }
});

const fetchDatasourceFeaturesSuccess = withDraft((draft, action) => {
  const item = findDatasourceFeature(draft, action);
  if (item) {
    assignProps(item, {
      ...action.result,
      readErrors: [],
      readStatus: states.SUCCESS,
    });
  }
});

const fetchDatasourceFeatures = withDraft((draft, action) => {
  const item = findDatasourceFeature(draft, action);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.features[action.category].results.push(newDatasourceFeatures(action));
  }
});

export default {
  [datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES]: fetchDatasourceFeatures,
  [datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES_ERROR]: fetchDatasourceFeaturesError,
  [datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES_SUCCESS]: fetchDatasourceFeaturesSuccess,
};
